import ReactDOM from 'react-dom';
import CameraStreamWindow from './CameraStreamWindow';

const CameraStreamWindowPortal = () => {
    const portalTarget =
        document.getElementById('camera-stream-window-root') ||
        (() => {
            const el = document.createElement('div');
            el.id = 'camera-stream-window-root';
            document.body.appendChild(el);
            return el;
        })();

    return ReactDOM.createPortal(<CameraStreamWindow />, portalTarget);
};

export default CameraStreamWindowPortal;
